module.exports = __webpack_public_path__ + "img/logo.19a904d7.png";